import { Modal } from '@mantine/core';
import type { ReactNode } from 'react';

interface FormModalProps {
  opened: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  size?: string;
}

export function FormModal({
  opened,
  onClose,
  title,
  children,
  size = 'md',
}: FormModalProps) {
  return (
    <Modal opened={opened} onClose={onClose} title={title} size={size} centered>
      {children}
    </Modal>
  );
}
